<template>
  <BaseDialog centered contentClass="delete-field-mapping-dialog" ref="dialog" :show-actions="true">
    <template slot="title">{{ $t('page.admin-sync-profiles.delete-mapping-dialog.title') }}</template>
    <template slot="content">
      <div class="delete-field-mapping-dialog__body">
        <i18n path="page.admin-sync-profiles.delete-mapping-dialog.message">
          <template v-slot:field>
            <strong>{{ mapping && mapping.crmFieldName }}</strong>
          </template>
        </i18n>
      </div>
      <div class="delete-field-mapping-dialog__actions">
        <FormButton is-outlined @click.native="closeDialog">{{ $t('actions.cancel') }}</FormButton>
        <FormButton is-danger @click.native="onConfirm">{{ $t('actions.delete') }}</FormButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import { mapActions } from 'vuex';

export default {
  name: 'DeleteFieldMappingDialog',
  components: { BaseDialog, FormButton },
  props: {
    profileId: {
      type: String,
      required: true,
    },
  },
  data() {
    return { mapping: null };
  },
  methods: {
    ...mapActions('adminSyncProfileFieldMappings', ['deleteFieldMapping']),
    openDialog(mapping) {
      this.mapping = mapping;
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onConfirm() {
      this.deleteFieldMapping({ profileId: this.profileId, mappingId: this.mapping.id })
        .then(() => {
          this.$toast.success(this.$t('page.admin-sync-profiles.delete-mapping-dialog.success'));
          this.$emit('action-succeeded');
          this.closeDialog();
        })
        .catch(() => this.$toast.error(this.$t('page.admin-sync-profiles.delete-mapping-dialog.error')));
    },
  },
};
</script>

<style lang="scss">
.base-dialog__delete-field-mapping-dialog {
  height: auto;
  width: 480px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}

.delete-field-mapping-dialog {
  &__body {
    font-size: 16px;
    margin-bottom: 24px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
}
</style>
